import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  BUSINESS = 'Business',
  HOSPITALITY = 'Hospitality',
  RETAIL = 'Retail',
  EARNINGS = 'Earnings',
  ENERGY = 'Energy & Oil',
  AUTOS = 'Autos',
  MEDIA = 'Media',
  LOGISTICS = 'Logistics',
  DEALS = 'Deals',
  TELECOM = 'Telecom',
  AIRLINES = 'Airlines',
  ENTREPRENEURSHIP = 'Entrepreneurship',
  C_SUITE = 'C-Suite',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['business'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/deals'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/retail'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/earnings'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/autos'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/energy-oil'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/airlines'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/c-suite'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/hospitality'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/media'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/logistics'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/telecom'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['business/entrepreneurship'] } }
    ]
  }
};

const HOSPITALITY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/hospitality'] } }]
  }
};

const RETAIL = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/retail'] } }]
  }
};

const EARNINGS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/earnings'] } }]
  }
};

const ENERGY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/energy-oil'] } }]
  }
};
const AUTOS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/autos'] } }]
  }
};
const MEDIA = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/media'] } }]
  }
};
const LOGISTICS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/logistics'] } }]
  }
};
const DEALS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/deals'] } }]
  }
};
const TELECOM = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/telecom'] } }]
  }
};
const AIRLINES = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/airlines'] } }]
  }
};
const ENTREPRENEURSHIP = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/entrepreneurship'] } }]
  }
};
const C_SUITE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['business/c-suite'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: [
            'business',
            'business/deals',
            'business/retail',
            'business/earnings',
            'business/autos',
            'business/energy-oil',
            'business/airlines',
            'business/c-suite',
            'business/hospitality',
            'business/media',
            'business/logistics',
            'business/telecom',
            'business/entrepreneurship'
          ]
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'business' } }, { prefix: { key: 'DJEThing', value: 'business/' } }],
    not: []
  }
};

export {
  MAIN,
  SECTION_ENUM,
  HOSPITALITY,
  RETAIL,
  EARNINGS,
  ENERGY,
  AUTOS,
  MEDIA,
  LOGISTICS,
  DEALS,
  TELECOM,
  AIRLINES,
  ENTREPRENEURSHIP,
  C_SUITE,
  RELATED_OPINION,
  VIDEO
};
